<div class="wrapper">
  <div class="badges_title">
    <svg-icon style="height: 20px; margin-right: 5px;" [svgStyle]="{'width.px': 20, 'height.px': 20}" src="/assets/icons/shield_empty.svg"></svg-icon>
    <h2 class="dot_after">Badges</h2>
    <div class="text medium">{{badges.length}} badges earned</div>
  </div>
</div>
<div class="badge_list">
  <app-badge *ngFor="let group of badgeGroups" [badgeGroup]="group"></app-badge>
</div>

<!--<div class="badge_buttons">-->
<!--  <button [@fadeIn] (click)="recommend();">-->
<!--    <svg-icon [svgStyle]="{'width.px': 25}" src="/assets/icons/thumb_2.svg"></svg-icon>-->
<!--    <span>Recommend</span>-->
<!--  </button>-->

<!--  <button [@fadeIn] (click)="recommend();">-->
<!--    <svg-icon style="height: 22px;" src="/assets/icons/plus_2.svg"></svg-icon>-->
<!--    <span>Add to map</span>-->
<!--  </button>-->
<!--</div>-->
